import React, { useState } from 'react';
import { Badge, Button, Tooltip } from '@heroui/react';
import { Bell } from 'lucide-react';
import WhatsNewDrawer from './WhatsNewDrawer.js';
import { useChangelog } from './useChangelog.js';

function WhatsNewButton({ area }) {
	const [isOpen, setIsOpen] = useState(false);
	const changelog = useChangelog({ area });

	return (
		<>
			<Badge
				content={changelog.newItemsCount}
				color="primary"
				size="md"
				isInvisible={changelog.newItemsCount === 0}
				shape="circle"
			>
				<Tooltip content="What's New" placement="bottom">
					<Button
						isIconOnly
						variant="light"
						aria-label="What's new"
						// Enforce a ≥44px touch target (HeroUI `sm` is 32px, `md` 40px) per
						// Web Interface Guidelines; w-11/h-11 = 44px.
						//
						// A visible gray chip at rest, washing PRIMARY blue on hover (USER) —
						// notifications are the product's color, only RSS owns the orange.
						// `bg-primary/15` compiles to its own class name, so legacy Bootstrap's
						// bare `.bg-primary{!important}` never matches it; the hover text uses
						// the raw token for the same reason. The unread Badge wraps this
						// button, keeps its own primary chip and stacking, and needs no change.
						className="min-w-11 w-11 h-11 bg-default-100 text-default-600 data-[hover=true]:bg-primary/15 data-[hover=true]:text-[hsl(var(--heroui-primary))]"
						onPress={() => setIsOpen(true)}
					>
						<Bell className="w-5 h-5" />
					</Button>
				</Tooltip>
			</Badge>
			<WhatsNewDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} changelog={changelog} />
		</>
	);
}

export default WhatsNewButton;
